/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_DescInputs */

const en_cp_form_desc = /** @type {(inputs: Cp_Form_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep it short. We reply by email with a suggested model, calendar, and price.`)
};

const id_cp_form_desc = /** @type {(inputs: Cp_Form_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isi singkat saja. Kami balas lewat email dengan usulan model, kalender, dan harga.`)
};

/**
* | output |
* | --- |
* | "Keep it short. We reply by email with a suggested model, calendar, and price." |
*
* @param {Cp_Form_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_desc = /** @type {((inputs?: Cp_Form_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_desc(inputs)
	return en_cp_form_desc(inputs)
});